import {ShopSettings} from '../classes/shop.settings';
import {WindowRef} from '../service/window-ref.service';

export class ConfigurationHelper {
	private static winRef: WindowRef = new WindowRef();

	/**
	 * @param {string} relativeUrl
	 * @return {string} the absolute webshop url.
	 */
	static getWebshopUrl(relativeUrl: string): string {
		let webshopBaseUrl = ConfigurationHelper.getWebshopBaseUrl();

		webshopBaseUrl = webshopBaseUrl.endsWith('/')
			? webshopBaseUrl.slice(0, -1)
			: webshopBaseUrl;

		if (!relativeUrl) {
			return webshopBaseUrl;
		}

		// Ensure relativeUrl starts with '/'
		if (!relativeUrl.startsWith('/')) {
			relativeUrl = '/' + relativeUrl;
		}

		return webshopBaseUrl + relativeUrl;
	}

	static getWebsiteUrl(relativeUrl: string): string {
		let websiteBaseUrl = ConfigurationHelper.getCmsBaseUrl();
		websiteBaseUrl = websiteBaseUrl.endsWith('/')
			? websiteBaseUrl.slice(0, -1)
			: websiteBaseUrl;

		if (!relativeUrl.startsWith('/')) {
			relativeUrl = '/' + relativeUrl;
		}

		return websiteBaseUrl + relativeUrl;
	}

	static getWebshopLanguageIso2(): string {
		return this.winRef.nativeWindow.appLanguageCode;
	}

	/**
	 * @return {string} the base url for the webshop.
	 */
	static getWebshopBaseUrl(): string {
		return this.winRef.nativeWindow.webshopBaseUrl;
	}

	/**
	 * @return {string} the base url for the cms/site.
	 */
	static getCmsBaseUrl(): string {
		return this.winRef.nativeWindow.cmsBaseUrl;
	}

	/**
	 *
	 * @return {ShopSettings} the shop settings for the currently active shop.
	 * These settings are added in the index.html with Thymeleaf code as variable on the window object,
	 * so they can be used in Angular code.
	 */
	static getSettings(): ShopSettings {
		return this.winRef.nativeWindow.shopSettings;
	}

	/**
	 * Check if localStorage is enabled.
	 * @return {boolean} the value when localStorage is accessible
	 */
	static isLocalStorageEnabled(): boolean {
		try {
			const key = `__storage__test`;
			window.localStorage.setItem(key, 'null');
			window.localStorage.removeItem(key);
			return true;
		} catch (e) {
			return false;
		}
	}

	/**
	 * Check to see if the browser allows cookies.
	 * @return {boolean} the value of the navigator.cookieEnabled property
	 */
	static isCookiesAvailable(): boolean {
		return navigator.cookieEnabled;
	}

	/**
	 * Function that writes to localStorage
	 */
	static setItem(key: string, data: string) {
		window.localStorage.setItem(key, data);
	}

	/**
	 * Function that reads an item from localStorage
	 * @return {localStorage} localStorage item by key
	 */
	static getItem(key: string) {
		return window.localStorage.getItem(key);
	}

	/**
	 * Function that removes an item from localStorage
	 */
	static removeItem(key: string) {
		window.localStorage.removeItem(key);
	}

	/**
	 * Function that clears the localStorage
	 */
	static clearLocalStorage() {
		window.localStorage.clear();
	}
}
